var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2666 0.424805L20.5342 3.4248L20.5322 3.4209H9.15332L3.46387 13.2754L9.15332 23.1299H20.5322L20.5361 23.1211L22.2686 26.1221L22.2646 26.1309H7.42188L0 13.2764L7.42188 0.421875H22.2646L22.2666 0.424805Z",
    fill: "#DFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2461 12.5186L29.6904 13.2803L29.2402 14.0381L25.5879 20.2002H22.1143L22.1045 20.1943L25.3184 14.7744H10.3936V11.7734L25.3398 11.7744L22.1016 6.21973H25.5732L29.2461 12.5186Z",
    fill: "#DFF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/LOG-OUT-icon.08328f2a84facd3e860fd198f1c7a1a0.svg";
export { ForwardRef as ReactComponent };